import { Component, Input } from '@angular/core';

@Component({
  selector: 'rap-sort-arrows',
  templateUrl: './sort-arrows.component.html',
  styleUrls: ['./sort-arrows.component.scss']
})
export class SortArrowsComponent {
  @Input() column: string = '';
  @Input() sortedColumn: string = ''; // Currently sorted column
  @Input() sortDirection: 'asc' | 'desc'; // Sort direction

  ngOnInit(): void {
    console.log(this.column)
  }
}
